import styled from 'styled-components';

export interface Props {
  intro?: boolean;
  verseCount: number;
  selectedVerse: number;
  onClick: (verse: number) => void;
}

export const VerseBar = ({ intro, verseCount, selectedVerse, onClick }: Props) => {
  if (isNaN(verseCount)) {
    return null;
  }
  function renderVerses() {
    return [...Array(verseCount + (intro ? 1 : 0)).keys()].map((verseIndex) => {
      let name: string;
      if (intro && verseIndex === 0) {
        name = 'Int';
      } else {
        name = (intro ? verseIndex : verseIndex + 1).toString();
      }
      return (
        <Verse
          key={verseIndex}
          className="verse"
          id={name}
          style={
            verseIndex === selectedVerse ? { backgroundColor: 'var(--color-verse-selected)' } : { backgroundColor: '' }
          }
          onClick={() => onClick(verseIndex)}
        >
          {name}
        </Verse>
      );
    });
  }

  return <VerseContainer id="verseContainer">{renderVerses()}</VerseContainer>;
};

const VerseContainer = styled.div`
  margin-top: 0;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

const Verse = styled.div`
  font-size: 17px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  margin: 2px;
  cursor: pointer;
  font-weight: 500;
`;
